import * as React from "react";
import { Tabs, Tab } from "@focus/focusUI";
import { TabFormBuilder } from "./TabFormBuilder";
export const FocusFormTab = ({ schema, uiSchema, formData, errors, onChange, }) => {
    const buildTab = (tabName, schema, uiSchema, formData, errors) => {
        let tabSchema = Object.assign(Object.assign({}, schema), { title: schema.title || "", properties: schema.properties || {}, minProperties: schema.minProperties || Object.keys(schema.properties).length, description: "" });
        let tabUiSchema = Object.assign(Object.assign({}, uiSchema), { "ui:field": undefined, "ui:readOnly": undefined, "ui:hidden": undefined, "ui:label": undefined, "ui:units": undefined, "ui:legend": undefined, "ui:options": undefined, "ui:icons": undefined, "ui:disable": undefined, "ui:order": uiSchema["ui:order"] || [] });
        const tabErrors = errors ? errors : {};
        const isHidden = typeof uiSchema["ui:hidden"] !== "undefined" && !!uiSchema["ui:hidden"];
        const tab = isHidden ? null : (React.createElement(Tab, { key: tabName, id: tabName, disabled: !!uiSchema["ui:disabled"], title: schema.title, panel: React.createElement(TabFormBuilder, { key: tabName, schema: tabSchema, uiSchema: tabUiSchema, formData: formData, readOnly: uiSchema["ui:readOnly"], errors: tabErrors, onChange: handleChange(tabName) }) }));
        return tab;
    };
    const buildTabs = () => {
        let formTabs = [];
        const order = uiSchema["ui:order"];
        for (let i = 0; i < order.length; i++) {
            const tabName = order[i];
            formTabs.push(buildTab(tabName, schema.properties[tabName], uiSchema[tabName], formData[tabName], errors[tabName]));
        }
        formTabs = formTabs.filter((tab) => tab !== null);
        return (React.createElement(Tabs, { key: "formtabset", id: "FormWithTabs", className: "tabHolder", renderActiveTabPanelOnly: false }, formTabs));
    };
    const handleChange = (tabName) => (newData, change) => {
        let newFormData = Object.assign({}, formData);
        newFormData[tabName] = newData;
        onChange(newFormData, change);
    };
    const tab = buildTabs();
    return tab;
};
//# sourceMappingURL=FocusFormTab.js.map